import { computed, onMounted, onUnmounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useIntegratorStore } from '../stores/useIntegratorStore'
import { useIntegrator } from '#src/composables/useIntegrator'

export const useIntegratorChild = (childId: string) => {
  const { children } = storeToRefs(useIntegratorStore())
  const { awake, snooze, onChildLoaded } = useIntegrator()
  const child = computed(() => children.value.find((c) => c.childId === childId) ?? null)
  const isLoaded = computed(() => !!child.value?.isLoaded)
  const isAwake = computed(() => !!child.value?.isAwake)

  const activateChild = () => {
    if (!child.value) {
      return
    }

    child.value.isLoaded = true
    awake(childId)
    child.value.isAwake = true
  }

  const deactivateChild = () => {
    if (!child.value) {
      return
    }

    if (onChildLoaded.value === activateChild) {
      onChildLoaded.value = null
    }

    snooze(childId)
    child.value.isAwake = false
  }

  const removeChild = () => {
    if (!child.value) {
      return
    }

    child.value.isLoaded = false
  }

  onMounted(() => {
    onChildLoaded.value = activateChild
  })

  onUnmounted(() => {
    deactivateChild()
  })

  return {
    isLoaded,
    isAwake,
    activateChild,
    removeChild,
  }
}
